// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"806":"47903f91","1919":"47903f91","7856":"47903f91","9651":"1a4b2669"}[chunkId] + ".chunk.css";
};